// Copyright (c) Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.

/**
 * @internal
 */
export enum DropDownState {
  DEFAULT = 'default',
  LOADING = 'isLoading',
  HAS_ERROR = 'hasError',
}

/**
 * @internal
 */
export enum TemplateState {
  DEFAULT = 'default',
  LOADING = 'isLoading',
  HAS_ERROR = 'hasError',
  SHOW_TEMPLATE = 'showTemplate',
}
